﻿import $ from "jquery";
import { encode as encodeBase64 } from "./base64";

var downloadButtonSelector = ".ccs-download-button, .ccs-download-button a";

export default function enableDownload(download, options) {
	if (!download.isEnabled)
		return;

	const $downloadButtons = $(downloadButtonSelector);
	const $downloadLinks = $downloadButtons.filter('a[cspdoctitle]:not([cspdoctitle=""])');

	if (!$downloadLinks)
		return;

	convertInnerLinks($downloadLinks);

	$downloadLinks.each(function () {
		enableDownloadForm($(this), download.formUrl, options);
	});
}

function getAbsoluteHref(href) {
	if (href.indexOf("//") > 0)
		return href;

	var host = window.location.protocol + "//" + window.location.host;

	var pathname = window.location.pathname;
	var index = pathname.lastIndexOf("/") + 1;

	return host + pathname.substr(0, index) + href;
}

function convertInnerLinks($links) {
	var $innerLinks = $links.filter("a[href^='/'], a[href^='./'], a[href^='../']");

	$innerLinks.each(function () {
		var originHref = $(this).attr("href");
		var index = originHref.indexOf("/") + 1;

		var href = originHref.substr(index);

		$(this).attr("href", getAbsoluteHref(href));
	});
}

function getDownloadParametrs($downloadLink) {
	var parametrs = new Object();

	var href = $downloadLink.attr("href");
	var text = $downloadLink.attr("cspdoctitle");

	if (href.indexOf(window.location.host) === -1)
		href = getAbsoluteHref(href);

	if (href.length > 0)
		parametrs.Href = href;

	if (text.length > 0)
		parametrs.Text = text;

	return JSON.stringify(parametrs);
}

function enableDownloadForm($downloadLink, downloadFormUrl, options) {
	const context = options.context;
	const log = options.log;
	const downloadParametrs = getDownloadParametrs($downloadLink);

	if (!downloadParametrs)
		return;

	const autoHeightId = new Date().getTime();
	const eventQuery = `${context}&download=${encodeBase64(encodeURIComponent(downloadParametrs))}&AutoHeightId=${autoHeightId}`;
	const protocol = document.location.protocol === "https:" ? "https:" : "http:";
	const url = `${protocol}//${ccs_cc_initParams[1]}${downloadFormUrl}?${eventQuery}`;

	$downloadLink
		.addClass("iframe")
		.attr("href", url)
		.fancybox({
			type: "iframe",
			smallBtn: true,
			baseClass: "ccs-fancybox-dccn-features",
			iframe: {
				attr: {
					"data-autoheight-id": autoHeightId
				},
				css: { width: 430 }
			},
			afterLoad: function (instance, current) {
				current.$content.css("height", "auto");

				const logCall = log;
				const clientParams = {
					Action: "download"
				};
				ccs_cc_log.dispatchEvent(logCall, clientParams);
			}
		});
}
